import {ACTION_SET_AUTH_USER} from "./constants";

/**
 * Initial/ Fallback state
 */
const INITIAL_STATE = {
    authUser: null
};


/* -----------------    Actions     ------------------ */
/**
 * Action to set the {@code authUser} in the store based on the specified action
 */
const applySetAuthUser = (state, action) => ({
    ...state,
    authUser: action.authUser
});


/* -----------------    Session Reducer     ------------------ */
/**
 * Session Reducer that manages all actions related to the store
 */
function sessionReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case ACTION_SET_AUTH_USER:
            return applySetAuthUser(state, action);
        default:
            return state;
    }
}

export default sessionReducer;



// WEBPACK FOOTER //
// ./src/reducers/session.js